import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosBuzzOne } from '../../../../axios';
import {
  adminDigitalDeliverableRoute,
  deleteDigitalDocRoute,
  deleteSchoolAgreementRoute,
  deleteSchoolDocRoute,
  schoolDetailsRoute,
  schoolRoute,
  updateSchoolAgreementRoute,
  updateSchoolDigitalDeliverableRoute,
  updateSchoolDocRoute,
  updateSchoolRoute,
  userRoute,
  usersRoute,
} from '../../utils/apiRoutes';
import { moduleName } from '../../module';
import { uploadPhotoRoute } from '../../../common/utils/apiRoutes';

export const createTeenybeansSchoolAsync = createAsyncThunk(
  `${moduleName}/createTeenybeansSchoolAsync`,
  async (payload) => {
    const response = await axiosBuzzOne({
      method: 'POST',
      url: schoolRoute(),
      data: payload,
    });
    const data = response.data;
    return data;
  }
);

export const getSingleSchoolAsync = createAsyncThunk(
  `${moduleName}/getSingleSchoolAsync`,
  async (id) => {
    const response = await axiosBuzzOne({
      method: 'GET',
      url: schoolDetailsRoute('65f2c38e82cb19cca9693d80'),
    });
    const data = response.data;
    return data;
  }
);

export const createTeenybeansUserAsync = createAsyncThunk(
  `${moduleName}/createTeenybeansUserAsync`,
  async (payload) => {
    const response = await axiosBuzzOne({
      method: 'POST',
      url: userRoute(),
      data: payload,
    });
    const data = response.data;
    return data;
  }
);

export const updateSchoolAsync = createAsyncThunk(
  `${moduleName}/updateSchoolAsync`,
  async (payload) => {
    const response = await axiosBuzzOne({
      method: 'PATCH',
      url: updateSchoolRoute(payload.id),
      data: payload.data,
      // headers: { 'x-user-type': 'BCC' },
    });
    const data = response.data;
    return data;
  }
);

export const getAllSchoolAsync = createAsyncThunk(
  `${moduleName}/getAllSchoolAsync`,
  async (payload) => {
    const { params } = payload;
    const response = await axiosBuzzOne({
      method: 'GET',
      url: schoolRoute(),
      params: { ...params },
      data: payload,
    });
    const data = response.data;
    return data;
  }
);

export const getAllUserAsync = createAsyncThunk(
  `${moduleName}/getAllUserAsync`,
  async (payload) => {
    const { params } = payload;
    const response = await axiosBuzzOne({
      method: 'GET',
      url: usersRoute(),
      params: { ...params },
      data: payload,
    });
    const data = response.data;
    return data;
  }
);

export const uploadFileAsync = createAsyncThunk(
  `${moduleName}/uploadFileAsync`,
  async (payload, { rejectWithValue }) => {
    try {
      if (payload.file) {
        const data = new FormData();
        data.append('document', payload.file);
        const localAxios = payload.authToken
          ? axiosBuzzOne({
              authToken: payload.authToken,
              contentType: 'multipart/form-data',
            })
          : axiosBuzzOne;
        const response = await localAxios({
          method: 'POST',
          url: uploadPhotoRoute(),
          data,
        });
        return response.data;
      } else if (payload.files) {
        const localAxios = payload.authToken
          ? axiosBuzzOne({
              authToken: payload.authToken,
              contentType: 'multipart/form-data',
            })
          : axiosBuzzOne;
        const response = await localAxios({
          method: 'POST',
          url: uploadPhotoRoute(),
          data: payload.files,
        });
        return response.data;
      }
      throw new Error('No file');
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateSchoolAgreementAsync = createAsyncThunk(
  `${moduleName}/updateSchoolAgreementAsync`,
  async (payload) => {
    const response = await axiosBuzzOne({
      method: 'POST',
      url: updateSchoolAgreementRoute(payload.id),
      data: payload.data,
      // headers: { 'x-user-type': 'BCC' },
    });
    const data = response.data;
    return data;
  }
);

export const deleteSchoolAgreementAsync = createAsyncThunk(
  `${moduleName}/deleteSchoolAgreementAsync`,
  async (payload) => {
    const response = await axiosBuzzOne({
      method: 'DELETE',
      url: deleteSchoolAgreementRoute(payload),
    });
    const data = response.data;
    return data;
  }
);

export const deleteSchoolDocAsync = createAsyncThunk(
  `${moduleName}/deleteSchoolDocAsync`,
  async (payload) => {
    const response = await axiosBuzzOne({
      method: 'DELETE',
      url: deleteSchoolDocRoute(payload),
    });
    const data = response.data;
    return data;
  }
);

export const deleteDigitalAsync = createAsyncThunk(
  `${moduleName}/deleteDigitalAsync`,
  async (payload) => {
    const response = await axiosBuzzOne({
      method: 'DELETE',
      url: deleteDigitalDocRoute(payload),
    });
    const data = response.data;
    return data;
  }
);

export const updateSchoolDocsAsync = createAsyncThunk(
  `${moduleName}/updateSchoolDocsAsync`,
  async (payload) => {
    const response = await axiosBuzzOne({
      method: 'POST',
      url: updateSchoolDocRoute(payload.id),
      data: payload.data,
      // headers: { 'x-user-type': 'BCC' },
    });
    const data = response.data;
    return data;
  }
);

export const updateSchoolDigitalDeliverableAsync = createAsyncThunk(
  `${moduleName}/updateSchoolDigitalDeliverableAsync`,
  async (payload) => {
    const response = await axiosBuzzOne({
      method: 'POST',
      url: updateSchoolDigitalDeliverableRoute(payload.id),
      data: payload.data,
      // headers: { 'x-user-type': 'BCC' },
    });
    const data = response.data;
    return data;
  }
);

export const updateAdminSchoolDigitalDeliverableAsync = createAsyncThunk(
  `${moduleName}/updateAdminSchoolDigitalDeliverableAsync`,
  async (payload) => {
    const response = await axiosBuzzOne({
      method: 'PUT',
      url: adminDigitalDeliverableRoute(payload),
      data: payload.data,
      // headers: { 'x-user-type': 'BCC' },
    });
    const data = response.data;
    return data;
  }
);

const bccTeenybeansSlice = createSlice({
  name: `${moduleName}/bccTeenybeansSchool`,
  initialState: {
    loading: false,
    allSchool: null,
    allUser: null,
    singleSchoolDetails: null,
  },
  reducers: {},
  extraReducers: {
    // create school using POST api
    [createTeenybeansSchoolAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [createTeenybeansSchoolAsync.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [createTeenybeansSchoolAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    //GET SINGLE SCHOOL
    [getSingleSchoolAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [getSingleSchoolAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.singleSchoolDetails = action.payload;
    },
    [getSingleSchoolAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    // create user using POST api
    [createTeenybeansUserAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [createTeenybeansUserAsync.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [createTeenybeansUserAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    // update bcc user
    [updateSchoolAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [updateSchoolAsync.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [updateSchoolAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    // get all data
    [getAllSchoolAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [getAllSchoolAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.allSchool = action.payload;
    },
    [getAllSchoolAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    //
    [getAllUserAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [getAllUserAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.allUser = action.payload;
    },
    [getAllUserAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    //
    [uploadFileAsync.fulfilled]: (state) => {
      state.loading = false;
    },
    [uploadFileAsync.pending]: (state) => {
      state.loading = true;
    },
    [uploadFileAsync.rejected]: (state) => {
      state.loading = false;
    },
    // update school Agreement
    [updateSchoolAgreementAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [updateSchoolAgreementAsync.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [updateSchoolAgreementAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    // delete school agreement
    [deleteSchoolAgreementAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteSchoolAgreementAsync.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [deleteSchoolAgreementAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    // delete school document
    [deleteSchoolDocAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteSchoolDocAsync.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [deleteSchoolDocAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    // delete digital deliverables
    [deleteDigitalAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteDigitalAsync.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [deleteDigitalAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    //update school docs
    [updateSchoolDocsAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [updateSchoolDocsAsync.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [updateSchoolDocsAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    // update school digital deliverables
    [updateSchoolDigitalDeliverableAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [updateSchoolDigitalDeliverableAsync.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [updateSchoolDigitalDeliverableAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    // update admin school digital deliverables
    [updateAdminSchoolDigitalDeliverableAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [updateAdminSchoolDigitalDeliverableAsync.fulfilled]: (state, action) => {
      state.loading = false;
    },
    [updateAdminSchoolDigitalDeliverableAsync.rejected]: (state, action) => {
      state.loading = false;
    },
  },
});

export default bccTeenybeansSlice.reducer;
